import React from 'react'
import SnippeSection from './SnippeSection'

export default function Rct() {
    let f = ["import {\nBrowserRouter as Router,\nRoutes,\nRoute\n} from 'react-router-dom'\n", "<Router><Routes>\n<Route exact path ='/' element={$1}/>\n</Routes></Router>"]
    return (
        <>
            <h1 className='text-6xl my-color text-white text-center py-3 w-4/5 m-auto font-semibold rounded-3xl my-4 border-2 border-slate-900'>React Js</h1>
            <SnippeSection title="create-routes : React Router Dom" locate="" code={f} />
        </>
    )
}
